import { Schema } from "effect";

// Gmail channel data (excluding refreshToken)
export const GmailChannelData = Schema.Struct({
  _tag: Schema.Literal("gmail"),
  email: Schema.String,
  emailSignature: Schema.NullOr(Schema.String),
  gmailAccountName: Schema.NullOr(Schema.String),
  gmailAccountImage: Schema.NullOr(Schema.String),
});
export type GmailChannelData = typeof GmailChannelData.Type;

// Outlook channel data (excluding refreshToken)
export const OutlookChannelData = Schema.Struct({
  _tag: Schema.Literal("outlook"),
  email: Schema.String,
  emailSignature: Schema.NullOr(Schema.String),
  name: Schema.NullOr(Schema.String),
});
export type OutlookChannelData = typeof OutlookChannelData.Type;

// Facebook channel data (excluding accessToken, appScopedUserId)
export const FacebookChannelData = Schema.Struct({
  _tag: Schema.Literal("facebook"),
  pageId: Schema.String,
  pageName: Schema.NullOr(Schema.String),
  facebookProfilePicUrl: Schema.NullOr(Schema.String),
});
export type FacebookChannelData = typeof FacebookChannelData.Type;

// Instagram channel data (excluding accessToken, appScopedUserId)
export const InstagramChannelData = Schema.Struct({
  _tag: Schema.Literal("instagram"),
  pageId: Schema.String,
  pageName: Schema.NullOr(Schema.String),
  instagramBusinessAccountId: Schema.NullOr(Schema.String),
  instagramProfilePicUrl: Schema.NullOr(Schema.String),
});
export type InstagramChannelData = typeof InstagramChannelData.Type;

// Attentive channel data (excluding accessToken, accessTokenExpireTime)
export const AttentiveChannelData = Schema.Struct({
  _tag: Schema.Literal("attentive"),
  attentiveCompanyId: Schema.NullOr(Schema.String),
  attentiveCompanyName: Schema.NullOr(Schema.String),
});
export type AttentiveChannelData = typeof AttentiveChannelData.Type;

// Postscript channel data (excluding apiKey)
export const PostscriptChannelData = Schema.Struct({
  _tag: Schema.Literal("postscript"),
  shopId: Schema.NullOr(Schema.String),
});
export type PostscriptChannelData = typeof PostscriptChannelData.Type;

// TikTok channel data (excluding accessToken, refreshToken, accessTokenExpireTime, refreshTokenExpireTime)
export const TiktokChannelData = Schema.Struct({
  _tag: Schema.Literal("tiktok"),
  shopId: Schema.String,
  sellerName: Schema.NullOr(Schema.String),
  sellerRegion: Schema.NullOr(Schema.String),
});
export type TiktokChannelData = typeof TiktokChannelData.Type;

// Discriminated union of all integration channel data types
export const IntegrationChannelData = Schema.Union(
  GmailChannelData,
  OutlookChannelData,
  FacebookChannelData,
  InstagramChannelData,
  AttentiveChannelData,
  PostscriptChannelData,
  TiktokChannelData,
);
export type IntegrationChannelData = typeof IntegrationChannelData.Type;
